const initialState = {
    header: [], 
    
  
  };
  
  const DoctorApproverHeaderReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DAHEADER_SUCCESS':
            return {... state, header:action.payload};
            
            
            
      default:
        return state;
    }
  };
  
  export default DoctorApproverHeaderReducers;
  
  